module.exports = __webpack_public_path__ + "static/img/18100C_2_C_20210301_LC.bc00919.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/18100C_2_C_20210301_LC.png
// module id = WSxA
// module chunks = 0